import { StorageService } from './storage.service';
import {Inject, Injectable} from '@angular/core';
// Our pseudo server Storage we'll use on the server to replace localStorage
// This can handle most scenarios, but if you truly needed a server Memory Cache
// you'd want to use Redis or something here
let fakeInMemoryStore: any = {};
@Injectable()
export class ServerStorage implements StorageService {
  fakeInMemoryStore: any = {};
  constructor() {
    // @Inject(String) options: string
    this.fakeInMemoryStore['interstitial'] = {}
  }
  getItem(key: string): any {
    return fakeInMemoryStore[key] || undefined;
  }
  setItem(key: string, value: string): any {
    return (fakeInMemoryStore[key] = value);
  }
  removeItem(key: string) {
    try {
      delete fakeInMemoryStore[key];
    } catch (ex) {}
  }
  clear() {
    fakeInMemoryStore = {};
  }
}
